import svgUrl from "ni:svgr;7japrl5-U-0wKaTeGrsDfTOpN0w6-lY-JiAuoTPJ2hY";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiGroupBySIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M3 3h10v3H3V3Zm10 4H3v3.5a.5.5 0 0 0 .5.5H5V9a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2H3.5A1.5 1.5 0 0 1 2 10.5V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1Zm0 4V9H6v2h7Zm0 1v2H6v-2h7Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiGroupBySIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiGroupBySIcon)";
}